<template>
<div v-if="isShow">
    <header>ポイントの履歴<div class="h-left"><a @click="$emit('close')"><img src="~@/assets/images/icon02.svg"></a></div>
    </header>
    <div id="wrap">
        <div class="point-area">
            <table>
                <tr v-for="(item, index) in points" :key="index">
                    <td>{{ item.created_at }}</td>
                    <td>{{ item.description }}</td>
                    <td class="point-area02">{{ item.point > 0 ? '+' + item.point : item.point }}pt</td>
                </tr>
            </table>
        </div>
    </div>
    <infinite-loading @infinite="getPointHistory" spinner="spiral">
        <template v-slot:no-more></template>
        <template v-slot:no-results>
            <div id="middle">
                データーがない
            </div>
        </template>
    </infinite-loading>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex"
export default {
    props: {
        isShow: Boolean,
    },
    emits: ['close'],
    data: () => ({
        currentPage: 1,
        isGet: false,
        points: [],
        pageSize: 40
    }),
    computed: {
        ...mapGetters(["metadata", 'defaultToken']),
    },
    watch: {
        isShow(val) {
            if (val) {
                this.isGet = true
            }
        }
    },
    methods: {
        getPointHistory($state) {
            if (this.points.length > 0 && this.points.length < this.pageSize) {
                $state.complete();
                return;
            }
            if (this.isGet) {
                let params = {
                    token: this.defaultToken,
                    page: this.currentPage,
                    limit: this.pageSize
                }
                this.$store.dispatch('profile/getPointHistory', params).then(data => {
                    if (data[0]) {
                        this.points.push(...data)
                        this.currentPage++
                        if ($state) {
                            $state.loaded()
                        }
                    } else {
                        if ($state) {
                            $state.complete()
                        }
                    }
                }).catch(err => {
                    if ($state) {
                        $state.complete()
                    }
                }).catch(err => {
                    if ($state) {
                        $state.complete()
                    }
                })
            } else {
                if ($state) {
                    $state.complete()
                }
            }
        }
    }
}
</script>
